(function() {
    var httpRequest = new XMLHttpRequest();
    httpRequest.onreadystatechange = alertContents;
    httpRequest.open('GET', '/collections/all/products.json?limit=250', true);
    httpRequest.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    httpRequest.send();
    function alertContents() {
        if (httpRequest.readyState === XMLHttpRequest.DONE) {
            if (httpRequest.status === 200) {
                var response = JSON.parse(httpRequest.responseText);
                products = response.products;
				
                let prod = "";
                let assocfieldid = {};
                for (let j = 0; j < document.getElementsByClassName('fessuravariantscolor').length; j++) {
                    prod = String(document.getElementsByClassName('fessuravariantscolor')[j].dataset.attr).split("|");
                    //console.log(prod); 
                    assocfieldid[prod[4]] = prod[0];
                }
				
                const classes = document.getElementsByClassName('type_collection');
                if (classes.length > 0) {
                    for (let j = 0; j < document.getElementsByClassName('fessuravariantscolor').length; j++) {
                     
                        if (String(document.getElementsByClassName('fessuravariantscolor')[j]['innerHTML']).length > -1) {
                            prod = String(document.getElementsByClassName('fessuravariantscolor')[j].dataset.attr).split("|");
                            let htmltoinject = "";
                            for (let k = 0; k < products.length; k++) {
                                /*for (const [m, v] of Object.entries(assocfieldid)) {
                                    if ((products[k].id == m) && (prod[0] == v)) {
                                        if (String(products[k].options[0].values[0]).toLowerCase() != String(prod[1]).toLowerCase()) {
                                            if (prod[5] == "en") {
                                                htmltoinject += '<div class="item"><a href="/en/products/' + products[k].handle + '" title="' + products[k].title + '"><img src="' + products[k].images[0].src + '"></a></div>';
                                            } else {
                                                htmltoinject += '<div class="item"><a href="/products/' + products[k].handle + '" title="' + products[k].title + '"><img src="' + products[k].images[0].src + '"></a></div>';
                                            }
                                        }
                                    }
                                }*/
                                //if (htmltoinject == "") {
                            
                                    if (products[k].title.toLowerCase() == prod[3].toLowerCase()) {
                                   
                                        if (String(products[k].options[0].values[0]).toLowerCase() != String(prod[1]).toLowerCase()) {
                                            htmltoinject += '<div class="item"><a href="/products/' + products[k].handle + '" title="' + products[k].title + '"><img src="' + products[k].images[0].src + '"></a></div>';
                                            //console.log("[JS][step2] " + products[k].title);
                                        }
                                    }
                                //}
                            }
                            document.getElementsByClassName('fessuravariantscolor')[j].innerHTML = htmltoinject;
                        }
                    }
                }
            }
        }
    }
    document.addEventListener('DOMContentLoaded', (event) => {
        const element = document.getElementById('facet-filters');
        if (element) {
            const observer = new MutationObserver(alertContents);
            observer.observe(element, {
                childList: true,
                subtree: true,
                attributes: true
            });
        }
    });
})();